export default __webpack_public_path__ + "static/media/terms.0205737d.pdf";